$(document).ready(function() {
    setTimeout(function() {
        $('a.pick_currency').appendTo('.currency');
    }, 2000);
});

document.addEventListener('DOMContentLoaded', () => {
  const contentArea = document.querySelector('main.content-retiro-2');

  if (!contentArea) {
    return;
  }

  const links = contentArea.querySelectorAll('a[href]');
  const currentHost = window.location.hostname;

  links.forEach(link => {
    if (link.hostname && link.hostname !== currentHost) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });
});

